import store from "../store/Store";

export function isPersonaCardOpen(): boolean {
    return store().isPersonaCardOpen;
}
